export const getRouteReporting = () => ({
	id: 'issue-navigator',
	packageName: 'issueNavigator',
	teamName: 'empanada',
});
